<template>
  <div class="container">
    <Compareface v-if="type === 'compareface'"></Compareface>
    <FlowChart v-if="type === 'flowChart'"></FlowChart>
    <ExamSnapshot v-if="type === 'snapshot'"></ExamSnapshot>
    <ComparePhoto v-if="type === 'comparePhoto'"></ComparePhoto>
  </div>
</template>

<script>
import Compareface from "./compareface.vue";
import FlowChart from "./flow-chart.vue";
import ExamSnapshot from "./exam-snapshot.vue";
import ComparePhoto from "./compare-photo.vue";
export default {
  name: "show-talk-window",
  components: {
    Compareface,
    FlowChart,
    ExamSnapshot,
    ComparePhoto
  },
  data() {
    return {
      type: "",
    };
  },
  created() {
    this.initType()
    this.initConnect()
  },
  methods: {
    initConnect() {
      const _this = this
      if (window.core) {
        const _this = this
        const connectTalkWindowUpdated = function (open) {
          _this.onHandleTalkWindowUpdated(open);
        };
        // 订阅原生事件
        window.core.talkWindowUpdated.connect(connectTalkWindowUpdated);
        this.$once("hook:beforeDestroy", () => {
          // 销毁页面后取消订阅，避免多次订阅
          window.core.talkWindowUpdated.disconnect(connectTalkWindowUpdated);
        });
      } else {
        setTimeout(() => {
          _this.initConnect()
        }, 1000)
      }
    },
    onHandleTalkWindowUpdated(open) {
      if (open) {
        this.type = ''
        this.initType()
      } else {
        this.$utils.$localStorage.remove("commonWindowType")
        this.type = ''
      }
    },
    initType() {
      const commonWindowType = this.$utils.$localStorage.get("commonWindowType")
      this.type = commonWindowType
    }
  },
};
</script>

<style scoped>
.container {
  width: 100%;
  height: 100%;
  background: #fff;
}
</style>
